import React from 'react';
import { Navigate, Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import Home from '../../../module/home/pages/home';
import { Footer, Header } from '../index';
import AboutUs from '../../../module/aboutUs/pages/about';
import ContactUs from '../../../module/contactUs/pages/contact';
import CreateProfile from '../../../module/createProfile/pages/createProfile';
import CareerPage from '../../../module/career/pages/careerPage';
import JobBlog from '../../../module/career/pages/jobBlog';
import RegisterPage from '../../../module/auth/page/register';
import HealthSupport from '../../../module/service/pages/healthSupport';
import HomeService from '../../../module/service/pages/homeService';
import NursingService from '../../../module/service/pages/nursingService';
import LoginSignUp from '../../../module/login/pages/loginSignup';
import NursingJobs from '../../../module/nursingJobs/pages/nursingJobs';
import EmployerRoutes from './employerRoutes';
import EmployeeRoutes from './employeeRoutes';
import PublicRoute from './publicRoute';

const AppRouter: React.FC = () => {
    const menuData = [
        { name: 'Home', path: '/' },
        { name: 'About Us', path: '/about-us' },
        {
            name: 'Services', subMenu: [
                {name: 'Help at Home Services', path: '/home-service'},
                {name: 'Nursing Services', path: '/nursing'},
                {name: 'Mental Health and Wellbeing Services', path: '/health'}
            ]
        },
        { name: 'Contact Us', path: '/contact-us' },
    ]

    return (
        <>
            <Router>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <>
                                <Header menuList={menuData} buttonLabel='Login/Signup' buttonLink='/login-signup' />
                                <Home />
                            </>
                        }
                    />
                    <Route
                        path="/about-us"
                        element={
                            <>
                                <Header menuList={menuData} buttonLabel='Login/Signup' buttonLink='/login-signup' />
                                <AboutUs />
                            </>
                        }
                    />
                    <Route
                        path="/contact-us"
                        element={
                            <>
                                <Header menuList={menuData} buttonLabel='Login/Signup' buttonLink='/login-signup' />
                                <ContactUs />
                            </>
                        }
                    />
                    <Route
                        path="/create-profile"
                        element={
                            <>
                                <Header buttonLabel='Sign In / Sign Up' buttonLink='/' />
                                <CreateProfile />
                            </>
                        }
                    />
                    <Route
                        path="/career"
                        element={
                            <>
                                <Header menuList={menuData} buttonLabel='Sign In / Sign Up' buttonLink='/find-jobs' />
                                <CareerPage />
                            </>
                        }
                    />
                    <Route
                        path="/find-jobs"
                        element={
                            <>
                                <Header buttonLabel='Contact Us' buttonLink='/contact-us' />
                                <JobBlog />
                            </>
                        }
                    />
                    <Route
                        path="/registrations"
                        element={
                            <>
                                <Header menuList={menuData} buttonLabel='Contact Us' buttonLink='/contact-us' />
                                <RegisterPage />
                            </>
                        }
                    />
                    <Route
                        path="/health"
                        element={
                            <>
                                <Header menuList={menuData} buttonLabel='Contact Us' buttonLink='/contact-us'  />
                                <HealthSupport />
                            </>
                        }
                    />
                    <Route
                        path="/home-service"
                        element={
                            <>
                                <Header menuList={menuData} buttonLabel='Contact Us' buttonLink='/contact-us'  />
                                <HomeService />
                            </>
                        }
                    />
                    <Route
                        path="/nursing"
                        element={
                            <>
                                <Header menuList={menuData} buttonLabel='Contact Us' buttonLink='/contact-us'  />
                                <NursingService />
                            </>
                        }
                    />


                    <Route
                        path="/nursing-jobs-in-new-zealand"
                        element={
                            <>
                                <Header menuList={menuData} buttonLabel='Contact Us' buttonLink='/contact-us' />
                                <NursingJobs />
                            </>
                        }
                    />

                    <Route
                        path="/login-signup"
                        element={
                            <PublicRoute>
                                <>
                                    <Header menuList={menuData} buttonLabel="Login/Signup" buttonLink="/login-signup" />
                                    <LoginSignUp />
                                </>
                            </PublicRoute>
                        }
                    />

                     {/* Employer Area */}
                    <Route path="/employer/*" element={<EmployerRoutes />} />

                    {/* Employee Area */}
                    <Route path="/employee/*" element={<EmployeeRoutes />} />

                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
                <Footer />
            </Router>
        </>
    )
}
export default AppRouter;
